import {
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { history, useModel, useNavigate, useParams } from '@umijs/max';
import type { MenuProps } from 'antd';
import { Avatar, Dropdown, Select, Spin } from 'antd';
import { createStyles } from 'antd-style';
import React, { useEffect, useState } from 'react';
import { flushSync } from 'react-dom';
import { outLogin } from '@/services/ant-design-pro/api';
import HeaderDropdown from '../HeaderDropdown';
import {  getFormData, replacePathSegment } from '../../utils/utils.js';

export type GlobalHeaderRightProps = {
  menu?: boolean;
  children?: React.ReactNode;
};
 export const loginOut = async () => {
  //当前没有退出登录接口改为清除token
    // await outLogin();
    localStorage.removeItem('carbonToken');
    const { search, pathname } = window.location;
    const urlParams = new URL(window.location.href).searchParams;
    const searchParams = new URLSearchParams({
      redirect: pathname + search,
    });
    /** 此方法会跳转到 redirect 参数所在的位置 */
    const redirect = urlParams.get('redirect');
    // Note: There may be security issues, please note
    if (window.location.pathname !== '/user/login' && !redirect) {
      history.replace({
        pathname: '/user/login',
        search: searchParams.toString(),
      });
    }
  };
export const AvatarName = () => {
  const { initialState } = useModel('@@initialState');
  const { currentUser } = initialState || {};
  console.log(currentUser?.name.slice(0,1),'currentUser');
  return (
    <Dropdown menu={{
      onClick:({key})=>{
        if(key==='logout'){
          loginOut()
        }
      },
      items: [
        {
          label: (
            <div style={{display:'flex',alignItems:'center'}}>
            <LogoutOutlined style={{ marginRight: 8 }} />
            退出登录
            </div>
          ),
          key: 'logout',
        },
      ],
    }}>
<div style={{cursor:'pointer'}}>
        <Avatar
        // src={currentUser?.avatar}
        size={32}
        style={{ marginRight: 8 ,backgroundColor:'#00A870'}}
      >
      {currentUser?.name.slice(0,1)}  
      </Avatar>
      <span className="anticon" style={{ color: '#2F3643' }}>
      {currentUser?.name}
    </span>
</div>
    </Dropdown>
  );
};

const useStyles = createStyles(({ token }) => {
  return {
    action: {
      display: 'flex',
      height: '48px',
      marginLeft: 'auto',
      overflow: 'hidden',
      alignItems: 'center',
      padding: '0 8px',
      cursor: 'pointer',
      borderRadius: token.borderRadius,
      '&:hover': {
        backgroundColor: token.colorBgTextHover,
      },
    },
  };
});
export const ProjectSelect =()=>{
    const path = window.location.pathname;
    const [options,setOptions]=useState([])
    const navigate=useNavigate()
  const { initialState, setInitialState } = useModel('@@initialState');
  const params = useParams();


    const  onChange =(e:any,item:any)=>{
       const newPath = replacePathSegment(path, 1, item?.code);
      navigate(newPath);
      setInitialState((s) => ({ ...s, curProject: item }));
      
    }
    const getProjectOptions =()=>{
    getFormData({
        page: 1,
        page_size: 999,
        constant: {
          classId:'project'
        },
      }).then((res)=>{
        console.log(res,'rres');
        setOptions(res?.rows?.map((e)=>{
          return {
            ...e,
            value:e?.code,
            label:e?.name
          }
        }))
      })  
    }
    useEffect(()=>{
      getProjectOptions()
    },[])
    // const getPorjectDetail=(id:string)=>{
    //   getFormData({
    //     page: 1,
    //     page_size: 1,
    //     constant: {
    //       classId:'project',
    //     },
    //     filter_cond:{
    //       op:'and',
    //       filters:[
    //         {
    //           field:'code',
    //           op:'=',
    //           value:id
    //         }
    //       ]
    //     }

    //   }).then((res)=>{     
    //     console.log(res,'rreks');
           
    //     setInitialState((s) => ({ ...s, curProject: res?.rows?.[0] }));
    //   })  
    // }
    // useEffect(()=>{
    //   if(params.id&&initialState?.curProject?.code!==params.id){
    //     // setInitialState((s) => ({ ...s, curProject: undefined }));
    //     getPorjectDetail(params.id)
    //   }
    // },[params.id])
  return  <Select
  showSearch
  onChange={onChange}
  options={options}
  value={initialState?.curProject?.code}
   filterOption={(input, option) => 
        option.label.toLowerCase().includes(input.toLowerCase())
      }
  allowClear
  style={{width:300,marginRight:20}}
  />
}
export const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({
  menu,
  children,
}) => {
  /**
   * 退出登录，并且将当前的 url 保存
   */
 
  const { styles } = useStyles();

  const { initialState, setInitialState } = useModel('@@initialState');

  const onMenuClick: MenuProps['onClick'] = (event) => {
    const { key } = event;
    if (key === 'logout') {
      flushSync(() => {
        setInitialState((s) => ({ ...s, currentUser: undefined }));
      });
      loginOut();
      return;
    }
    history.push(`/account/${key}`);
  };

  const loading = (
    <span className={styles.action}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const { currentUser } = initialState;

  if (!currentUser || !currentUser.name) {
    return loading;
  }

  const menuItems = [
    ...(menu
      ? [
          {
            key: 'center',
            icon: <UserOutlined />,
            label: '个人中心',
          },
          {
            key: 'settings',
            icon: <SettingOutlined />,
            label: '个人设置',
          },
          {
            type: 'divider' as const,
          },
        ]
      : []),
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
    },
  ];
  
  return (
    <HeaderDropdown
      menu={{
        selectedKeys: [],
        onClick: onMenuClick,
        items: menuItems,
      }}
    >
      {children}
    </HeaderDropdown>
  );
};

